import { Component, OnDestroy, OnInit } from '@angular/core';
import _ from 'lodash';
import { PageFavorite } from '../../../../models/page-favorite';
import { Chapter } from '../../../../models/chapter';
import { PageFavoriteService } from '../../../../services/page-favorite.service';
import { ChapterService } from '../../../../services/chapter.service';
import { Subscription } from 'rxjs';
import { CommunicationService } from '../../../../services/communication.service';
import { SinglePageFavoriteComponent } from './single-page-favorite/single-page-favorite.component';
import { MainChapterHeadingComponent } from '../../../utils/main-chapter-heading/main-chapter-heading.component';

@Component({
    selector: 'sidebar-page-favorites-content',
    templateUrl: './page-favorites-content.component.html',
    styleUrls: ['./page-favorites-content.component.scss'],
    standalone: true,
    imports: [
        SinglePageFavoriteComponent,
        MainChapterHeadingComponent
    ]
})
export class PageFavoritesContentComponent implements OnInit, OnDestroy {

    pageFavorites: Array<PageFavorite>;
    chapters: Array<Chapter>;
    chapterPageFavorites: Array<{ chapter: Chapter; pageFavorites: Array<PageFavorite> }>;
    favoritesBeforeFirstChapter: Array<PageFavorite>;

    contentChangedSubscription: Subscription;

    constructor(private pageFavoritesService: PageFavoriteService,
                private communicationService: CommunicationService,
                private chapterService: ChapterService) {
        this.contentChangedSubscription = this.communicationService.bookFeatureDataChangedAnnouncedSource$.subscribe(ele => {
            if (ele.bookFeature instanceof PageFavorite) {
                this.fetchData();
            }
        });
    }

    ngOnInit(): void {
        this.fetchData();
    }

    ngOnDestroy(): void {
        this.contentChangedSubscription.unsubscribe();
    }

    filterAssignmentPavorites(favorites: Array<PageFavorite>, assignmentFavorites: boolean): Array<PageFavorite> {
        if (!favorites) {
            return [];
        }

        return favorites.filter(favorite => !!favorite.assignmentSlug === assignmentFavorites);
    }

    private fetchData(): void {

        this.pageFavoritesService.getPageFavorites().then(result => {

            this.pageFavorites = result;
            this.chapterService.getChapters().then(result => {

                this.chapterPageFavorites = [];
                this.chapters = result;

                this.handleFavoritesBeforeFirstChapter();

                this.chapters.forEach(chapter => {

                    this.chapterService.getMainChapterStartAndEndIndex(chapter).then(indizes => {
                        this.putFavoritesIntoChapter(chapter, indizes);
                    });
                });
            });
        });
    }

    private putFavoritesIntoChapter(chapter: Chapter, startAndEndIndizes: Array<number>): void {

        const chapterStartAndEndIndizes = startAndEndIndizes;
        let favoritesInChapter = _.filter(this.pageFavorites, pageFavorite => {
            return pageFavorite.index >= chapterStartAndEndIndizes[0] && pageFavorite.index < chapterStartAndEndIndizes[1];
        });
        favoritesInChapter = _.sortBy(favoritesInChapter, ele => {
            return ele.index;
        });
        this.chapterPageFavorites.push({ chapter, pageFavorites: favoritesInChapter });
    }

    private handleFavoritesBeforeFirstChapter(): void {

        let firstChapterIndex = Number.MAX_VALUE;

        if (this.chapters.length >= 1) {
            firstChapterIndex = this.chapters[0].index;
        }

        let favoritesWithoutChapter = _.filter(this.pageFavorites, pageFavorite => {
            return pageFavorite.index >= 0 && pageFavorite.index < firstChapterIndex;
        });

        favoritesWithoutChapter = _.sortBy(favoritesWithoutChapter, ele => {
            return ele.index;
        });

        this.favoritesBeforeFirstChapter = favoritesWithoutChapter;
    }
}
